const CartService = function (TicketFormatService, ShippingMethodService, Config, Discount) {
    return {
        /**
         * @var {null|TicketFormat}
         */
        ticketFormat: null,
        /**
         * @var {null|ShippingMethod}
         */
        shippingMethod: null,

        deprecated: { $scope: null },

        /**
         * @type {Object<Cart.Product>}
         */
        items: [],
        sum: 0,
        realSum: 0,
        paymentVoucher: null,
        paymentMethod: null,

        hasValidPayment: function () {
            return this.paymentMethod
                || this.paymentVoucher
                || this.deprecated.$scope.amazonLoggedIn
                || this.sum <= 0 && Discount.item;
        },

        /**
         * @param {Cart.Product} item
         * @param {String} key
         * @return {Promise}
         */
        removeProduct: function (item, key) {
            delete this.items[ key ];
            this.removeItemFormLocalstorage(item);
            return this.deprecated.$scope.removeFromCart(item, key);
        },

        removeAllGiftwrapper: function () {
            var cart = this.items;
            var item;
            for (var key in cart) {
                if (!cart.hasOwnProperty(key)) {
                    continue;
                }
                item = cart[ key ];
                if (item.isGiftWrapper === true) {
                    this.removeProduct(item, key);
                }
            }
        },

        haveTickets: function () {
            var cart = this.items;
            var haveTickets = false;
            Object.keys(cart).forEach(function (key) {
                if (!haveTickets) {
                    haveTickets = (cart[ key ].type === 'event' || cart[ key ].type === 'bundle');
                }
            });
            return haveTickets;
        },

        haveBuyableItems: function () {
            var cart = this.items;
            var haveBuyableItems = false;
            Object.keys(cart).forEach(function (key) {
                if (!haveBuyableItems) {
                    var type = cart[ key ].type;
                    haveBuyableItems = (type === 'event' || type === 'bundle' || type === 'voucher' || type === 'product');
                }
            });
            return haveBuyableItems;
        },

        removeDiscount: function () {
            var cart = this.items;
            var that = this;
            Object.keys(cart).forEach(function (key) {
                if (cart[ key ].type === 'discounttype') {
                    that.removeProduct(cart[ key ], key);
                }
            });
        },

        /**
         * @returns {boolean}
         */
        hasOnlyGiftwrapper: function () {
            var cart = this.items;
            var item;
            var haveGiftwrapper = false;
            var haveSomethingElse = false;

            for (var key in cart) {
                if (!cart.hasOwnProperty(key)) {
                    continue;
                }
                item = cart[ key ];
                if (item.isGiftWrapper === true) {
                    haveGiftwrapper = true;
                } else {
                    haveSomethingElse = true;
                }
            }
            return haveGiftwrapper && !haveSomethingElse;
        },

        /**
         * @returns {Array<string>}
         */
        getCartProductIDs: function () {
            var cart = this.items;
            var shortCart = [];
            for (var key in cart) {
                if (!cart.hasOwnProperty(key)) {
                    continue;
                }
                var item = cart[ key ];
                if (item.hasOwnProperty("productcategoriesid")) {
                    shortCart.push(item.productcategoriesid + "-" + item.id);
                } else {
                    shortCart.push(String(item.id));
                }
            }
            return shortCart;
        },

        /**
         * @param {number} productID
         * @param {number?} productCategoryID    if not set, it search if the productID is in the "no-category"-group
         * @returns {boolean}
         */
        cartHasProductID: function (productID, productCategoryID) {
            if (typeof productCategoryID === "undefined") {
                return (this.getCartProductIDs().indexOf(String(productID)) > -1);
            }
            else {
                return (this.getCartProductIDs().indexOf(productCategoryID + "-" + productID) > -1);
            }
        },

        /**
         * @param {Cart.ProductCategory} productCategory
         * @returns {boolean}
         */
        haveProductsOfCategory: function (productCategory) {
            var cart = this.items;
            var haveProducts = false;
            for (var key in cart) {
                if (!cart.hasOwnProperty(key)) {
                    continue;
                }
                var product = cart[ key ];
                if (product.hasOwnProperty("productcategoriesid") && product.productcategoriesid === productCategory.id) {
                    haveProducts = true;
                    break;
                }
            }
            return haveProducts;
        },

        /**
         * @param {Object<Cart.Product>} items
         * @returns {Cart}
         */
        setItems: function (items) {
            this.items = items;
        },

        /**
         * Set default Ticket Format - color if possible - first if not
         *
         * @returns {boolean} show ShippingOptions ?
         */
        setDefaultTicketFormat: function () {
            var showShippingOptions = false;
            if (!this.ticketFormat && TicketFormatService.formats.length) {
                var format = TicketFormatService.getDefaultFormatByConfig();
                if (format !== null) {
                    this.setTicketFormat(format);
                    showShippingOptions = true;
                } else {
                    this.setTicketFormat(TicketFormatService.formats[ 0 ]);
                }

            }
            return showShippingOptions;
        },

        /**
         * @param {TicketFormat} ticketFormat
         */
        setShippingVisibilityByTicketFormat: function (ticketFormat) {
            var numberOfShippingOptions = 0;
            var defaultIdentifier = false;
            var preselectedIdentifier = false;
            var minExpensesIdentifier = null;
            var key = null;
            var minExpenses = null;

            for (var i = 0; i < ShippingMethodService.methods.length; i++) {
                var shippingMethod = ShippingMethodService.methods[ i ];
                var shippingMethodVisibility = false; //default
                var expenses = parseInt(shippingMethod.expenses);
                if (shippingMethod[ 'ticketformats' ] && shippingMethod[ 'ticketformats' ][ ticketFormat.ticketformattype ]) {
                    shippingMethodVisibility = true;
                    numberOfShippingOptions++;
                    key = i;

                    if (this.shippingMethod && shippingMethod.id === this.shippingMethod.id) {
                        preselectedIdentifier = i;
                    }
                    if (Config.default_shippingmethod_checkout !== false && shippingMethod.id === parseInt(Config.default_shippingmethod_checkout)) {
                        defaultIdentifier = i;
                    } else if (minExpenses === null || minExpenses > expenses) {
                        minExpensesIdentifier = i;
                        minExpenses = expenses;
                    }
                }

                ShippingMethodService.methods[ i ].visible = shippingMethodVisibility;
                if (this.shippingMethod && this.shippingMethod.id === ShippingMethodService.methods[ i ].id && !ShippingMethodService.methods[ i ].visible) {
                    this.resetShippingMethod();
                }
            }

            this.deprecated.$scope.updateCartSum();
            this.deprecated.$scope.numberOfShippingOptions = numberOfShippingOptions;

            if (numberOfShippingOptions === 1) {
                this.setShippingMethod(ShippingMethodService.methods[ key ]);
            } else if (preselectedIdentifier !== false) {
                this.setShippingMethod(ShippingMethodService.methods[ preselectedIdentifier ]);
            } else if (defaultIdentifier !== false) {
                this.setShippingMethod(ShippingMethodService.methods[ defaultIdentifier ]);
            } else if (minExpensesIdentifier !== null) {
                this.setShippingMethod(ShippingMethodService.methods[ minExpensesIdentifier ]);
            }

            if (!this.shippingMethod) {
                this.deprecated.$scope.setShowShippingOptions(true);
            }
        },

        /**
         *
         * @param {TicketFormat} item
         */
        setTicketFormat: function (item, forceCheckShippingVisibility) {
            forceCheckShippingVisibility = forceCheckShippingVisibility || false;
            if ((item && this.ticketFormat !== item) || forceCheckShippingVisibility) {
                this.ticketFormat = item;
                this.deprecated.$scope.scrollCartToBottom();
                this.setShippingVisibilityByTicketFormat(item);

                this.setDefaultPaymentMethod();
            }

            if (this.ticketFormat && (item && item.ticketformattype === this.ticketFormat.ticketformattype) && (TicketFormatService.formats.length > 1)) {
                this.deprecated.$scope.showTicketFormatOptions = !this.deprecated.$scope.showTicketFormatOptions;
            } else {
                this.deprecated.$scope.setShowTicketFormatOptions(false);
            }
        },

        /**
         * @returns {Cart}
         */
        resetTicketFormat: function () {
            this.ticketFormat = null;
            return this;
        },

        getFirstVisibleOrLastShippingMethod: function () {
            var shippingMethod;
            for (var index in this.ticketFormat.shippingmethods) {
                if (this.ticketFormat.shippingmethods.hasOwnProperty(index) && typeof index !== 'function') {
                    shippingMethod = ShippingMethodService.getShippingMethodByID(index);

                    if (shippingMethod.visible === true) {
                        break;
                    }
                }
            }
            return shippingMethod;
        },

        /**
         * Set default Shipping Method - standard shipping if possible
         *
         * @returns {number}
         */
        setDefaultShippingMethod: function () {
            if (!this.shippingMethod && ShippingMethodService.methods && 0 === TicketFormatService.formats.length && !this.ticketFormat) {
                var defaultIdentifier = 0;
                for (var i = 0; i < ShippingMethodService.methods.length; i++) {
                    var shippingMethod = ShippingMethodService.methods[ i ];

                    if (Config.default_shippingmethod_checkout !== false && shippingMethod.id === parseInt(Config.default_shippingmethod_checkout)) {
                        defaultIdentifier = i;
                        break;
                    }
                }
                this.shippingMethod = ShippingMethodService.methods[ defaultIdentifier ];
            }
            if (!this.shippingMethod && ShippingMethodService.methods.length && (TicketFormatService.formats.length > 0 || this.deprecated.$scope.onlyVoucherInCart)) {
                if (!this.ticketFormat) {
                    this.shippingMethod = ShippingMethodService.methods[ 0 ];
                    return 0;
                }
                var sm;
                var shippingMethodOne = ShippingMethodService.getShippingMethodByID(1);

                if (this.ticketFormat.shippingmethods.length === 1) {
                    sm = ShippingMethodService.getShippingMethodByID(this.ticketFormat.shippingmethods[ 0 ]);
                } else if ((typeof this.ticketFormat.shippingmethods[ 1 ] !== 'undefined') && (typeof shippingMethodOne !== 'undefined')) {
                    sm = shippingMethodOne;
                } else {
                    sm = this.getFirstVisibleOrLastShippingMethod();
                }
                this.setShippingMethod(sm);
            }
        },

        setDefaultPaymentMethod: function () {
            if (typeof amazonLoggedIn !== 'undefined') {
                this.deprecated.$scope.amazonLoggedIn = amazonLoggedIn ? amazonLoggedIn : false;
                this.deprecated.$scope.setAmazonPayment();
            } else if (this.deprecated.$scope.cartSum === 0 && !this.deprecated.$scope.paymentMethod && typeof amazonLoggedIn === 'undefined') {
                for (var i = 0; i < this.deprecated.$scope.paymentMethods.length; i++) {
                    if (this.deprecated.$scope.paymentMethods[ i ].identifier === 'free') {
                        this.deprecated.$scope.setPaymentMethod(this.deprecated.$scope.paymentMethods[ i ]);
                        break;
                    }
                }
            }
        },

        setPaymentMethod: function () {
            if (this.deprecated.$scope.cartSum > 0) {
                if (this.deprecated.$scope.paymentMethods.length === 1) {
                    this.deprecated.$scope.setPaymentMethod(this.deprecated.$scope.paymentMethods[ 0 ]);

                    if (typeof ga !== "undefined") {
                        // Tracking B: If ticketformat, shipping method and payment method shows up at once
                        ga('set', 'page', 'newCO_Ticket_Versand_Payment');
                        ga('send', 'pageview');
                    }
                } else {
                    if (this.deprecated.$scope.paymentMethod === false) {
                        this.deprecated.$scope.paymentMethod = null;

                        if (typeof ga !== "undefined" && this.ticketFormat && this.shippingMethod) {
                            // Tracking A 1: If ticketformat and shipping method is given, but no payment method
                            ga('set', 'page', 'newCO_Shipment');
                            ga('send', 'pageview');
                        }
                    }
                }
            } else {
                this.deprecated.$scope.paymentMethod = false;
            }
        },

        validatePaymentMethod: function (paymentMethod) {
            if (!paymentMethod || !paymentMethod.id) {
                return false;
            }

            for (var key in this.deprecated.$scope.paymentMethods) {
                if (!this.deprecated.$scope.paymentMethods.hasOwnProperty(key)) {
                    continue;
                }

                if (parseInt(this.deprecated.$scope.paymentMethods[ key ].id) === parseInt(paymentMethod.id)) {
                    return true;
                }
            }
            return false;
        },

        /**
         * @param {ShippingMethod} item
         */
        setShippingMethod: function (item) {
            // Defensive: allow callers to clear the shipping method without throwing
            if (!item || typeof item.id === 'undefined' || item === null) {
                this.resetShippingMethod();

                if (this.deprecated.$scope) {
                    this.deprecated.$scope.setShowShippingOptions(false);
                    this.deprecated.$scope.checkCheckoutPossible();
                    this.deprecated.$scope.updateCartSum();
                    this.deprecated.$scope.contentConfirm = null;
                }
                return;
            }

            // Toggle the UI only when user re-selects the currently selected method
            var canToggle = this.deprecated.$scope && this.deprecated.$scope.numberOfShippingOptions > 1;
            var isSameAsCurrent = this.shippingMethod && item.id === this.shippingMethod.id;

            if (canToggle && isSameAsCurrent) {
                this.deprecated.$scope.showShippingOptions = !this.deprecated.$scope.showShippingOptions;
            } else if (this.deprecated.$scope) {
                this.deprecated.$scope.setShowShippingOptions(false);
            }

            this.shippingMethod = item;

            if (this.deprecated.$scope) {
                this.deprecated.$scope.scrollCartToBottom();
                this.deprecated.$scope.checkCheckoutPossible();
                this.deprecated.$scope.updateCartSum();
                this.deprecated.$scope.contentConfirm = null;
            }

            this.setPaymentMethod();
        },

        /**
         * @returns {Cart}
         */
        resetShippingMethod: function () {
            this.shippingMethod = null;
            return this;
        },

        /**
         * @returns {Cart}
         */
        resetPaymentMethod: function () {
            this.paymentMethod = null;
            return this;
        },


        /**
         * only to use old methods
         * @param $scope
         */
        setScope: function ($scope) {
            this.deprecated.$scope = $scope;
            this.items = $scope.cartItems;
            var that = this;
            $scope.$watch('cartItems', function (newValue) {
                that.setItems(newValue);
                if (typeof $scope.updateCartSum === 'function') {
                        $scope.updateCartSum();
                }
            }, true);
        },

        /**
         * Removing items from localstorage (used for new frontend)
         * @param {} item
         */
        removeItemFormLocalstorage: function (item) {
            var storageCart = JSON.parse(localStorage.getItem('cart')) || [];
            var updatedCart = [];
            switch (item.type) {
                case 'product':
                    updatedCart = storageCart.filter(function (cartItem) {
                        return (cartItem.productId + '-' + cartItem.productSizeId !== item.productid) && cartItem.productId !== item.productid;
                    });
                    break;
                default:
                // do nothing
            }
            localStorage.setItem('cart', JSON.stringify(updatedCart));
        }
    };
};
    /**
     * The Cart or Basket
     * atm. the items in the cart are in scope of checkout-controller ($scope.cartItems)
     */
export default CartService;
